module.exports = __webpack_public_path__ + "static/media/Background-Right.8d188d39.jpg";